export const setHeaderMenus = (menus) => ({
    type: "SET_HEADER_MENUS",
    payload: menus,
  });
  